<template>
	<html lang="en" xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:th="http://www.thymeleaf.org"
		  xmlns:sec="http://www.thymeleaf.org/thymeleaf-extras-springsecurity3">
	<div class="alert alert-danger" role="alert"
		 th:text="${session.SPRING_SECURITY_LAST_EXCEPTION.getMessage()}"
		 th:if="${session.SPRING_SECURITY_LAST_EXCEPTION!=null}"></div>
	<!-- 修改密码表单 -->
	<form class="form-signin" method="post" action="/changepassword"
		  onsubmit='return checkForm()'>
		<input type="text" id="username" name="username"
			   class="form-control" placeholder="用户名" required th:value="${username}">
		<input type="password" id="oldPassword" name="oldPassword"
			   class="form-control" placeholder="原密码" required>
		<input type="password" id="newPassword" name="newPassword"
			   class="form-control" placeholder="新密码" required>
		<button class="btn btn-lg btn-primary btn-block" type="submit">确认修改</button>
	</form>
	</html>
</template>

<script>

export default {
name: "changepassword"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/changepassword.vue